module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning"
  }, [(_vm.noKidsAdded) ? [_c('h3', {
    staticClass: "warning__header"
  }, [_vm._v("Добавить обучающегося")]), _c('p', {
    staticClass: "warning__text"
  }, [_vm._v("Вы можете добавить не более 7 человек.")])] : [_c('h3', {
    staticClass: "warning__header"
  }, [_vm._v("В целях безопасности изменение данных ограничено.")]), _c('p', {
    staticClass: "warning__text"
  }, [_vm._v("Для внесения изменений информации о детях, просьба обратиться в техническую поддержку ЦОПП.")])], (_vm.dataSupport) ? _c('div', {
    staticClass: "warning__sevice"
  }, [(!!_vm.dataSupport.email) ? _c('div', {
    staticClass: "warning__data"
  }, [_vm._v("Электронная почта: "), _c('TextEmail', {
    attrs: {
      "value": _vm.dataSupport.email,
      "inline": true
    }
  })], 1) : _vm._e(), (_vm.dataSupport.phone) ? _c('div', {
    staticClass: "warning__data"
  }, [_vm._v("Телефон технической поддержки: "), _c('ExtPhone', {
    attrs: {
      "phone": _vm.dataSupport.phone
    }
  })], 1) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0627c157","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/warning/Warning.vue
// module id = a7e69c064449bee8b822
// module chunks = 8